import fetchHandler from "../../utils/fetchHandler";
import { MY_PROGRESS } from "../types/actions";

export const getMyProgressList = (day) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans/plan_for_day/?weekday=${day}`,
		method: "GET",
		actionType: MY_PROGRESS.GET_MY_PROGRESS_LIST
	};
	return fetchHandler(fetchOptions);
};

export const getMyHistoryGraph = (queryString = "") => {
	const fetchOptions = {
		url: `/api/exercises/my_history/?${queryString}`,
		method: "GET",
		actionType: MY_PROGRESS.GET_MY_HISTORY_GRAPH
	};
	return fetchHandler(fetchOptions);
};
